<template>
  <div>
    <a @click="$router.back()" class="color-gray-100 d-inline-block text-semiBold mb-4">
      <span class="icon-ico-back me-2"></span>
      Penjualan
    </a>

    <div class="d-flex justify-content-between align-items-center mb-3">
      <div class="col">
        <div class="position-relative">
          <div class="form-search">
            <input type="text" class="form-control" v-debounce:300.lock="searchSales" placeholder="Cari nomor penjualan" value="" v-model="salesSearch">
          </div>
        </div>
      </div>
      <div class="col-auto ms-3">
        <a @click="exportSales()" class="text-base filter text-medium">Export</a>
      </div>
    </div>

    <nav>
      <div class="nav nav-tabs border-0 bsales-0" id="information-tab" role="tablist">
        <button class="nav-link" :class="salesStatus == 0 ? 'active': ''" id="bantuan-tab" data-bs-toggle="tab" data-bs-target="#bantuan" type="button"
          role="tab" aria-controls="bantuan" aria-selected="true" @click="salesStatus = 0">Permintaan</button>
        <button class="nav-link" :class="[1,2,3,4,'allDiterima','allDiproses'].includes(salesStatus) ? 'active': ''" id="tentang-kfs-tab" data-bs-toggle="tab" data-bs-target="#tentang-kfs" type="button"
          role="tab" aria-controls="tentang-kfs" aria-selected="false" @click="salesStatus = 'allDiterima'">Diterima</button>
        <button class="nav-link" :class="salesStatus == -2 ? 'active': ''" id="syarat-tab" data-bs-toggle="tab" data-bs-target="#syarat" type="button"
          role="tab" aria-controls="syarat" aria-selected="false" @click="salesStatus = -2">Ditolak</button>
        <button class="nav-link" :class="salesStatus == -1 ? 'active': ''" id="cancel-tab" data-bs-toggle="tab" data-bs-target="#cancel" type="button"
          role="tab" aria-controls="cancel" aria-selected="false" @click="salesStatus = -1">Dibatalkan</button>
        <button class="nav-link" :class="salesStatus == -3 ? 'active': ''" id="komplain-tab" data-bs-toggle="tab" data-bs-target="#komplain" type="button"
          role="tab" aria-controls="komplain" aria-selected="false" @click="salesStatus = -3">Komplain</button>
      </div>
    </nav>
    <div class="tab-content pt-4">
      <div class="tab-pane fade" :class="salesStatus == 0 ? 'show active': ''" id="bantuan" role="tabpanel" aria-labelledby="bantuan-tab" tabindex="0"></div>
      <div class="tab-pane fade" :class="[1,2,3,4,'allDiterima','allDiproses'].includes(salesStatus) ? 'show active': ''" id="tentang-kfs" role="tabpanel" aria-labelledby="tentang-kfs-tab" tabindex="0">
        <ul class="nav nav-tabs border-0 bsales-0 mb-3" id="tabTop" role="tablist">
          <li class="nav-item" role="presentation">
            <button class="nav-link" :class="salesStatus == 'allDiterima' ? 'active': ''" id="all" data-bs-toggle="tab" data-bs-target="#all-pane" type="button" @click="salesStatus = 'allDiterima'"
              role="tab" aria-controls="all-pane" aria-selected="true">Semua</button>
          </li>
          <li class="nav-item" role="presentation">
            <button class="nav-link" :class="salesStatus == 1 ? 'active': ''" id="waiting-tab" data-bs-toggle="tab" data-bs-target="#waiting-tab-pane" @click="salesStatus = 1"
              type="button" role="tab" aria-controls="waiting-tab-pane" aria-selected="false">Pembayaran</button>
          </li>
          <li class="nav-item" role="presentation">
            <button class="nav-link" :class="salesStatus == 'allDiproses' ? 'active': ''" id="layanan-tab" data-bs-toggle="tab" data-bs-target="#layanan-tab-pane" @click="salesStatus = 'allDiproses'"
              type="button" role="tab" aria-controls="layanan-tab-pane" aria-selected="false">Proses</button>
          </li>
          <li class="nav-item" role="presentation">
            <button class="nav-link" :class="salesStatus == 4 ? 'active': ''" id="selesai-tab" data-bs-toggle="tab" data-bs-target="#selesai-tab-pane" @click="salesStatus = 4"
              type="button" role="tab" aria-controls="selesai-tab-pane" aria-selected="false">Selesai</button>
          </li>
        </ul>
        <div class="tab-content" id="myTabContent">
          <div class="tab-pane fade" :class="salesStatus == 'allDiterima' ? 'show active': ''" id="all-pane" role="tabpanel" aria-labelledby="all-tab" tabindex="0"></div>
          <div class="tab-pane fade" :class="salesStatus == 2 ? 'show active': ''" id="waiting-tab-pane" role="tabpanel" aria-labelledby="waiting-tab" tabindex="0"></div>
          <div class="tab-pane fade" :class="salesStatus == 'allDiproses' ? 'show active': ''" id="layanan-tab-pane" role="tabpanel" aria-labelledby="layanan-tab" tabindex="0"></div>
          <div class="tab-pane fade" :class="salesStatus == 4 ? 'show active': ''" id="selesai-tab-pane" role="tabpanel" aria-labelledby="selesai-tab" tabindex="0"></div>
        </div>
      </div>
      <div class="tab-pane fade" :class="salesStatus == -2 ? 'show active': ''" id="syarat" role="tabpanel" aria-labelledby="syarat-tab" tabindex="0"></div>
      <div class="tab-pane fade" :class="salesStatus == -1 ? 'show active': ''" id="cancel" role="tabpanel" aria-labelledby="cancel-tab" tabindex="0"></div>
      <div class="tab-pane fade" :class="salesStatus == -3 ? 'show active': ''" id="komplain" role="tabpanel" aria-labelledby="komplain-tab" tabindex="0"></div>
    </div>

    <div class="row gx-3" v-if="saleses.length > 0">
      <CardPO v-for="sales in saleses" :key="sales.id" :data="sales"/>
    </div>
    <p class="text-center text-sm" v-if="saleses.length == 0">Tidak ada penjualan</p>
    <p class="text-center text-sm" v-if="saleses.length > 0 && salesCurrentPage < salesTotalPage">
      <a class="color-gray-100" @click="getSales( salesCurrentPage + 1 )">Muat lebih banyak <span class="icon-ico-chev-down"></span></a>
    </p>
  </div>
</template>

<script>
import CardPO from './components/CardPO.vue'

export default {
  components: {
    CardPO,
  },
  data() {
    return {
      saleses: [],
      salesCurrentPage: 1,
      salesTotalPage: 1,
      salesLimit: 10,
      salesSortby: 'id.desc',
      salesSearch: '',
      salesStatus: 0,
    }
  },
  methods: {
    searchSales() {
      this.saleses = []
      this.getSales(1)
    },
    getSales( page ) {
      let _ = this

      let status = _.salesStatus
      if (_.salesStatus == 'allDiterima') {
        status = 'in:1,2,3,4'
      } else if (_.salesStatus == 'allDiproses') {
        status = 'in:2,3'
      }

      _.axios.get('/purchase-orders/sales'
          + '?page=' + page
          + '&limit=' + _.salesLimit
          + '&sortBy=' + _.salesSortby
          + '&status=' + status
          + (_.salesSearch ? '&search=' + _.salesSearch : '')
        )
        .then( resp => {
          const data = resp.data.data
          if ( data.rows.length > 0 ) {
            _.salesCurrentPage = data.currentPage
            _.salesTotalPage = data.totalPages

            data.rows.forEach(elm => {
              _.saleses.push({ ...elm })
            });
          }
        })
        .catch( err => {
          _.$notify({
            type: 'error',
            title: 'Terjadi Kesalahan ('+err.response.data.code+')',
            text: err.response.data.message
          });
        })
    },
    exportSales() {
      let _ = this

      let status = _.salesStatus
      if (_.salesStatus == 'allDiterima') {
        status = 'in:1,2,3,4'
      } else if (_.salesStatus == 'allDiproses') {
        status = 'in:1,2'
      }

      _.axios.get('/purchase-orders/exports-sales'
          + '?status=' + status
          + (_.salesSearch ? '&search=' + _.salesSearch : '')
        ,{responseType: 'arraybuffer'})
        .then(resp => {
            let blob        = new Blob([resp.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
            let link        = document.createElement('a')
            link.href       = window.URL.createObjectURL(blob)
            link.download   = 'SALES-' + _.$moment().format('YYYYMMDDHHmmsss') + '.xlsx'
            link.click()
        })
        .catch( err => {
          _.$notify({
            type: 'error',
            title: 'Terjadi Kesalahan ('+err.response.data.code+')',
            text: err.response.data.message
          });
        })
    },
  },
  mounted() {
    if ( this.$route.query.salesStatus ) {
      this.salesStatus = this.$route.query.salesStatus
    } else {
      this.getSales(1)
    }
  },
  watch: {
    salesStatus: function() {
      this.saleses = []
      this.getSales(1)
    }
  }
}
</script>